import request from '../../utils/request'

// 查询
export function fetchList (type) {
  return request.get(`/business/company/tree?type=${type}`, {
    trim: true
  })
}

// export function fetchList (data) {
//   return request.post('/business/company/page', data, {
//     trim: true
//   })
// }

// 创建
export function create (data) {
  return request.post('/business/company/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/company/updateById', data)
}

// 部门信息同步
export function companySync (data) {
  return request.post('/business/company/syncAll', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/company/delete/${id}`)
}

// 根据类型查询组织信息
export function findCompanyTreePage (type) {
  return request.get(`/business/company/findCompanyTreePage?type=${type}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/company/delete/batch', {
    params: {
      ids
    }
  })
}
